/* esm.sh - d3-transition@3.0.1/src/transition/schedule */
export * from "/*d3-transition@3.0.1/esnext/src/transition/schedule.mjs";
export { default } from "/*d3-transition@3.0.1/esnext/src/transition/schedule.mjs";
